import React, { Component } from 'react';
import {
  Row, Col, Form, Select, Input, Radio, InputNumber, Checkbox, Button, Icon,
} from 'antd';
import autobind from 'react-autobind';
import PropTypes from 'prop-types';
import { formPropType } from 'utils/propType';
import { FormControl, FormRules, FormUtils } from 'form-control';
import InputMask from 'react-input-mask';
import translate from 'app/translations';
import { US_STATES, PROFILE_STEP_TYPES } from 'app/constants';
import AddressSearch from 'addresss-search/AddressSearch';
import AgentProfilePropType, { PayMethod } from '../AgentProfilePropType';
import WizardNav from './WizardNav';

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const { Option } = Select;

const NEW_MEXICO = 'NM';

export class CompanyProfileComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  onSubmit(nextPage) {
    const { form } = this.props;

    form.validateFieldsAndScroll((errors, values) => {
      if (!errors) {
        const payload = {
          ...values,
          crsId: values.crsId ? values.crsId : '',
          yearFounded: values.yearFounded && `${values.yearFounded}`.length > 0 ? Number(values.yearFounded) : undefined,
          isFirmIncorporated: FormUtils.yesNoToBoolean(values.isFirmIncorporated),
          paymentMethod: PayMethod.ECHECK.id,
        };
        this.props.onSaveCompanyProfileRequest(nextPage, payload);
      }
    });
  }

  onStateChange(state) {
    if (state !== NEW_MEXICO) {
      this.props.form.resetFields([
        'crsId',
      ]);
    }
  }

  getFieldFromFormOrState(fieldname) {
    let fieldValue = this.props.form.getFieldValue(fieldname);
    if (typeof fieldValue === 'undefined') {
      const { companyProfile } = this.props.agentProfile;
      fieldValue = companyProfile[fieldname];
      return fieldValue;
    }
    return fieldValue;
  }

  copyUserAddress() {
    const { form } = this.props;
    form.resetFields([
      'addressLine1',
      'addressLine2',
      'city',
      'state',
      'zipCode',
    ]);

    const { userProfile } = this.props.agentProfile;

    const {
      addressLine1,
      addressLine2,
      city,
      state,
      zipCode,
    } = userProfile;

    this.props.form.setFieldsValue({
      addressLine1: addressLine1 || undefined,
      addressLine2: addressLine2 || undefined,
      city: city || undefined,
      state: state || undefined,
      zipCode: zipCode || undefined,
    });
  }

  handleSearchAddressSelect(address) {
    const { form } = this.props;
    form.resetFields([
      'addressLine1',
      'addressLine2',
      'city',
      'state',
      'zipCode',
    ]);
    this.props.form.setFieldsValue({
      addressLine1: address.street1 || undefined,
      addressLine2: address.street2 || undefined,
      city: address.city || undefined,
      state: address.state || undefined,
      zipCode: address.zip || undefined,
    });
  }

  render() {
    const yesNoRadio = [
      { label: this.t('Generic.yes'), value: 'Yes' },
      { label: this.t('Generic.no'), value: 'No' },
    ];

    const placeHolderChar = '\u2000';
    const isReadOnly = '';
    const {
      form,
    } = this.props;

    const { companyProfile, constants, isCallInprogress } = this.props.agentProfile;

    const {
      COMPANY_UPDATE_RESPONSIBILITY,
      BUSINESS,
    } = constants;

    const formResponsibilityTypes = COMPANY_UPDATE_RESPONSIBILITY.map(rt => ({ checked: 'checked', label: rt.name, value: rt.value }));
    const defaultResponsibilityTypes = Array.isArray(companyProfile.responsibility) ? companyProfile.responsibility : [];

    return (
      <div className="user-profile">
        <Form layout="vertical">
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('CompanyProfile.profile')}</h2>
            <Row gutter={16}>
              <Col xs={24}>
                <FormControl
                  form={form}
                  fieldName="name"
                  displayName={this.t('CompanyProfile.name')}
                  initialValue={companyProfile.name}
                  rules={[FormRules.REQUIRED]}
                  readOnly={isReadOnly}
                >
                  <Input
                    maxLength={100}
                    autoComplete="off"
                    placeholder={this.t('CompanyProfile.name')}
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <FormControl
                  form={form}
                  fieldName="responsibility"
                  displayName={this.t('CompanyProfile.responsibility')}
                  initialValue={companyProfile.responsibility}
                  readOnly={isReadOnly}
                  isCheckbox="checkbox"
                  className="checkbox-group-grid-5"
                >
                  <CheckboxGroup
                    name="responsibility"
                    key={defaultResponsibilityTypes.join('-')}
                    defaultValue={defaultResponsibilityTypes}
                    options={formResponsibilityTypes}
                    style={{ width: '100%' }}
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="companyOwner"
                  displayName={this.t('CompanyProfile.companyOwner')}
                  initialValue={companyProfile.companyOwner}
                >
                  <Input
                    maxLength={100}
                    placeholder={this.t('CompanyProfile.companyOwner')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="keyContact"
                  displayName={this.t('CompanyProfile.keyContact')}
                  initialValue={companyProfile.keyContact}
                >
                  <Input
                    maxLength={100}
                    placeholder={this.t('CompanyProfile.keyContact')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <h2
                  style={{
                    marginRight: 8,
                  }}
                  className="inline-block orange-text"
                >
                  {this.t('CompanyProfile.w10Message')}
                </h2>
                <p>{this.t('CompanyProfile.w11Message')}</p>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <FormControl
                  form={form}
                  fieldName="paymentEmail"
                  displayName={this.t('CompanyProfile.paymentEmail')}
                  initialValue={companyProfile.paymentEmail}
                  rules={[FormRules.REQUIRED, { [FormRules.PATTERN]: FormUtils.regex.email }, { [FormRules.EMAILMATCH]: this.props.form.getFieldValue('paymentEmail1') }]}
                  readOnly={isReadOnly}
                >
                  <Input
                    type="email"
                    maxLength={100}
                    placeholder={this.t('CompanyProfile.paymentEmail')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <FormControl
                  form={form}
                  fieldName="paymentEmail1"
                  displayName={this.t('CompanyProfile.confirmPaymentEmail')}
                  initialValue={companyProfile.paymentEmail}
                  rules={[FormRules.REQUIRED, { [FormRules.PATTERN]: FormUtils.regex.email }, { [FormRules.EMAILMATCH]: this.props.form.getFieldValue('paymentEmail') }]}
                  readOnly={isReadOnly}
                >
                  <Input
                    type="email"
                    maxLength={100}
                    placeholder={this.t('CompanyProfile.confirmPaymentEmail')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <h3
                  style={{
                    marginRight: 8,
                  }}
                  className="inline-block"
                >
                  {this.t('CompanyProfile.address')}
                </h3>
                <p>{this.t('CompanyProfile.w9Message')}</p>
              </Col>
              <Col lg={24} xl={10}>
                <Button
                  className="btn-link ant-active-blue"
                  onClick={this.copyUserAddress}
                >
                  {this.t('CompanyProfile.sameAsUser')}
                  <Icon type="copy" />
                </Button>
                <div className="ant-row ant-form-item form-control">
                  <AddressSearch
                    onAddressSelected={this.handleSearchAddressSelect}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <FormControl
                  form={form}
                  fieldName="addressLine1"
                  displayName={this.t('CompanyProfile.addressLine1')}
                  initialValue={companyProfile.addressLine1}
                  rules={[FormRules.REQUIRED]}
                >
                  <Input
                    maxLength={45}
                    placeholder={this.t('CompanyProfile.addressLine1')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <FormControl
                  form={form}
                  fieldName="addressLine2"
                  displayName={this.t('CompanyProfile.addressLine2')}
                  initialValue={companyProfile.addressLine2}
                >
                  <Input
                    maxLength={45}
                    placeholder={this.t('CompanyProfile.addressLine2')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="city"
                  rules={[FormRules.REQUIRED]}
                  displayName={this.t('CompanyProfile.city')}
                  initialValue={companyProfile.city}
                >
                  <Input
                    maxLength={50}
                    placeholder={this.t('CompanyProfile.city')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={5}>
                <FormControl
                  form={form}
                  fieldName="state"
                  rules={[FormRules.REQUIRED]}
                  displayName={this.t('CompanyProfile.state')}
                  initialValue={companyProfile.state || undefined}
                >
                  <Select
                    showSearch
                    autoComplete="off"
                    filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                    placeholder={this.t('CompanyProfile.state')}
                    onChange={this.onStateChange}
                  >
                    {
                      US_STATES.map(s => (<Option value={s.value} key={s.value}>{s.name}</Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
              <Col xs={24} md={7}>
                <FormControl
                  form={form}
                  fieldName="zipCode"
                  displayName={this.t('CompanyProfile.zipCode')}
                  initialValue={companyProfile.zipCode}
                  rules={[FormRules.REQUIRED, { [FormRules.LENGTH]: [5, 5] }]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    autoComplete="off"
                    mask="99999"
                    maskChar=""
                    placeholder={this.t('CompanyProfile.zipCode')}
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <FormControl
                  form={form}
                  fieldName="email"
                  displayName={this.t('CompanyProfile.email')}
                  initialValue={companyProfile.email}
                  rules={[{ [FormRules.PATTERN]: FormUtils.regex.email }]}
                  readOnly={isReadOnly}
                >
                  <Input
                    type="email"
                    maxLength={100}
                    placeholder={this.t('CompanyProfile.email')}
                    autoComplete="off"
                  />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={8}>
                <FormControl
                  form={form}
                  fieldName="phoneNumber"
                  displayName={this.t('CompanyProfile.phoneNumber')}
                  initialValue={companyProfile.phoneNumber}
                  rules={[FormRules.REQUIRED, { [FormRules.LENGTH]: [12, 10] }]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="999\-999\-9999"
                    autoComplete="off"
                    maskChar={placeHolderChar}
                    placeholder={this.t('CompanyProfile.phoneNumber')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={4}>
                <FormControl
                  form={form}
                  fieldName="phoneNumberExt"
                  displayName={this.t('CompanyProfile.phoneNumberExt')}
                  initialValue={companyProfile.phoneNumberExt}
                  rules={[FormRules.POSITIVEINT]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="9999999999"
                    autoComplete="off"
                    maskChar=""
                    placeholder={this.t('CompanyProfile.phoneNumberExt')}
                  />
                </FormControl>
              </Col>

              <Col xs={24} md={8}>
                <FormControl
                  form={form}
                  fieldName="alternatePhoneNumber"
                  displayName={this.t('CompanyProfile.alternatePhoneNumber')}
                  initialValue={companyProfile.alternatePhoneNumber}
                  rules={[{ [FormRules.LENGTH]: [12, 10] }]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="999\-999\-9999"
                    autoComplete="off"
                    maskChar={placeHolderChar}
                    placeholder={this.t('CompanyProfile.alternatePhoneNumber')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={4}>
                <FormControl
                  form={form}
                  fieldName="alternatePhoneNumberExt"
                  displayName={this.t('CompanyProfile.alternatePhoneNumberExt')}
                  initialValue={companyProfile.alternatePhoneNumberExt}
                  rules={[FormRules.POSITIVEINT]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="9999999999"
                    autoComplete="off"
                    maskChar=""
                    placeholder={this.t('CompanyProfile.alternatePhoneNumberExt')}
                  />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <FormControl
                  form={form}
                  fieldName="faxNumber"
                  displayName={this.t('CompanyProfile.faxNumber')}
                  initialValue={companyProfile.faxNumber}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="999\-999\-9999"
                    autoComplete="off"
                    maskChar={placeHolderChar}
                    placeholder={this.t('CompanyProfile.faxNumber')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={4}>
                <FormControl
                  form={form}
                  fieldName="faxExt"
                  displayName={this.t('CompanyProfile.faxNumberExt')}
                  initialValue={companyProfile.faxExt}
                  rules={[FormRules.POSITIVEINT]}
                  readOnly={isReadOnly}
                >
                  <InputMask
                    className="ant-input"
                    mask="9999999999"
                    autoComplete="off"
                    maskChar=""
                    placeholder={this.t('CompanyProfile.faxNumberExt')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="businessType"
                  displayName={this.t('CompanyProfile.businessType')}
                  initialValue={companyProfile.businessType || undefined}
                >
                  <Select
                    showSearch
                    allowClear
                    autoComplete="off"
                    filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                    placeholder={this.t('CompanyProfile.businessType')}
                  >
                    {
                      BUSINESS.map(s => (<Option value={s.value} key={s.value}>{s.name}</Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={8}>
                <FormControl
                  form={this.props.form}
                  fieldName="isFirmIncorporated"
                  displayName={this.t('CompanyProfile.isFirmIncorporated')}
                  initialValue={FormUtils.booleanToYesNo(companyProfile.isFirmIncorporated) || undefined}
                  readOnly={this.isReadOnly}
                  validateTrigger="onChange"
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={4}>
                <FormControl
                  form={form}
                  fieldName="yearFounded"
                  displayName={this.t('CompanyProfile.yearFounded')}
                  initialValue={companyProfile.yearFounded}
                >
                  <InputNumber
                    className="establishedIn"
                    autoComplete="off"
                    maxLength={4}
                    min={1844}
                    max={(new Date()).getFullYear()}
                    size={4}
                    placeholder={this.t('CompanyProfile.yearFounded')}
                  />
                </FormControl>

              </Col>
              {this.getFieldFromFormOrState('state') === NEW_MEXICO && (
                <Col xs={24} md={12}>
                  <FormControl
                    form={form}
                    fieldName="crsId"
                    displayName={this.t('CompanyProfile.crsId')}
                    initialValue={companyProfile.crsId}
                    rules={[FormRules.REQUIRED]}
                  >
                    <Input
                      maxLength={25}
                      autoComplete="off"
                      placeholder={this.t('CompanyProfile.crsId')}
                    />
                  </FormControl>
                </Col>
              )}
            </Row>
          </div>
          <WizardNav
            agentProfile={this.props.agentProfile}
            isCallInProgress={isCallInprogress}
            currentPage={PROFILE_STEP_TYPES.COMPANY_PROFILE}
            onNavigate={this.onSubmit}
          />
        </Form>
      </div>
    );
  }
}

CompanyProfileComponent.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  form: PropTypes.shape(formPropType).isRequired,
  onSaveCompanyProfileRequest: PropTypes.func.isRequired,
};

export default Form.create()(CompanyProfileComponent);
